import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { QuizFacade } from '../facades/quizes.facade';
import { combineLatest, filter, map, take, tap } from 'rxjs';

export const quizLoaded: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const quizFacade = inject(QuizFacade);
    const quizId = route.paramMap.get('quizId');

    if (!quizId) {
        return createUrlTreeFromSnapshot(route, ['/dashboard']);
    }

    return combineLatest([quizFacade.quizId$, quizFacade.loaded$]).pipe(
        tap(([stateQuizId, loaded]) => {
            // Fetch if not loaded OR if loaded for a different quiz
            if (loaded !== true || stateQuizId !== quizId) {
                quizFacade.getQuiz(quizId);
            }
        }),
        filter(([stateQuizId, loaded]) => stateQuizId === quizId && loaded !== null),
        map(([, loaded]) => {
            if (loaded === false) {
                return createUrlTreeFromSnapshot(route, ['/dashboard']);
            }
            return true;
        }),
        take(1),
    );
};
